import {Component, Input, ViewEncapsulation} from '@angular/core';
import {IconProp} from 'ngx-satoris';

@Component({
  selector: 'pop-icon-button',
  templateUrl: './pop-icon-button.component.html',
  styleUrl: './pop-icon-button.component.scss',
  encapsulation: ViewEncapsulation.None
})
export class PopIconButtonComponent {
  @Input() icon: IconProp;
  @Input() label: string;
}
